import React, { useEffect, useState } from 'react';
// Added tracer import so that this package is included in marketings package.json
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import tracer from 'dd-trace';
import '../styles/app.scss';
import '@99designs/emu/fonts';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { ApolloProvider } from '@apollo/client';
import Bugsnag from '@bugsnag/js';
import * as smoothscroll from 'smoothscroll-polyfill';
import type { AppProps } from 'next/app';
import { BaseCss } from '@99designs/emu';
import { ExperimentsProvider } from '@99designs/experiments';
import { DEFAULT_GRAPH_ENDPOINT, createApolloClient } from '@99designs/graph-utils';
import { I18nProvider } from '../components/common/I18nProvider';
import { UIProvider } from '../components/common/UIProvider';
import initializeDatadogRum from '../lib/initializeDatadogRum';

Bugsnag.start({
    apiKey: process.env.NEXT_PUBLIC_MARKETING_BUGSNAG_API_KEY ?? '',
    enabledReleaseStages: ['production', 'sandbox', 'development'],
    releaseStage: process.env.NEXT_PUBLIC_MARKETING_BUGSNAG_RELEASE_STAGE,
    plugins: [new BugsnagPluginReact(React)],
});
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const ErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary();

function MarketingApp({ Component, pageProps }: AppProps) {
    const [host, setHost] = useState<string>(`https://${pageProps.host}`);

    useEffect(() => {
        initializeDatadogRum();
        smoothscroll.polyfill();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (window && window.Cypress) {
            setHost('https://99designs.com.integration.dockervm:39943');
        }
    }, []);

    const client = createApolloClient(`${host}${DEFAULT_GRAPH_ENDPOINT}`, pageProps.headers);
    const { locale, translations, experiments } = pageProps;

    return (
        <ErrorBoundary>
            <ApolloProvider client={client}>
                <I18nProvider
                    locale={locale}
                    translations={translations ? JSON.parse(translations) : {}}
                >
                    <ExperimentsProvider value={{ experiments: experiments ? experiments : '' }}>
                        <UIProvider>
                            <BaseCss />
                            <main>
                                <Component {...pageProps} />
                            </main>
                        </UIProvider>
                    </ExperimentsProvider>
                </I18nProvider>
            </ApolloProvider>
        </ErrorBoundary>
    );
}

export default MarketingApp;
